<template>
  <div class="nav-bar">
    <p>comori - <span>管理画面</span></p>
  </div>
</template>
<script>
export default {
  methods: {
  },
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
  },
}
</script>
